import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import {
  AlertType,
  removeAlert,
  alertSelectors,
} from '@/store/reducers/Alert/alertSlice';
import InlineAlert from '@cosmos/inline-alert';
import { toastTexts } from '@/assets/strings';

interface IProps {
  toast: AlertType;
}

const Toast: React.FC<IProps> = ({ toast }) => {
  const [timer, setTimer] = useState<number>(0);
  const [intervalID, setIntervalID] = useState<NodeJS.Timer>(null);

  const dispatch = useDispatch();

  useEffect(() => {
    handleStartTimer();
  }, []);

  useEffect(() => {
    if (timer === 3000) {
      handleCloseTimer();
    }
    //eslint-disable-next-line
  }, [timer]);

  const handleStartTimer = () => {
    const id = setInterval(() => {
      setTimer((prevTime) => {
        return prevTime + 1000;
      });
    }, 1000);
    setIntervalID(id);
  };

  const handlePauseTimer = () => {
    clearInterval(intervalID);
  };

  const handleCloseTimer = () => {
    handlePauseTimer();
    dispatch(removeAlert(toast?.id));
  };

  return (
    <>
      <div
        onMouseEnter={handlePauseTimer}
        onMouseLeave={handleStartTimer}
        className='single-alert'
      >
        {toast && (
          <InlineAlert
            className='inline-alert'
            type={toast?.alertType}
            text={toastTexts[toast?.alertType]}
            subText={toast?.message}
            onClose={() => dispatch(removeAlert(toast?.id))}
          />
        )}
      </div>
    </>
  );
};

const ToastList = () => {
  const alerts = useSelector(alertSelectors.selectAll, shallowEqual);
  if (alerts.length > 0) {
    return ReactDOM.createPortal(
      <div className='fixed top-18 right-16 z-40 flex flex-col gap-y-4'>
        {alerts?.map((alert) => (
          <div key={alert.id}>
            <Toast toast={alert} />
          </div>
        ))}
      </div>,
      document.getElementById('__next')
    );
  }

  return null;
};

export default ToastList;
